module.exports = __webpack_public_path__ + "static/media/vaspa-ghana.8dbee7aa.png";